import { Injectable } from '@angular/core';
import { tap, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BoToastrService, BoSpinnerService } from '../../shared';
import { API } from '../config/api';
import { SUCCESS } from '../../../@shared/constants';
import { ErrorResponse } from '../config/common';
import { RequestPODAdditionalDrop, CreatePODAdditionalDrop } from './pod-additional-drop.DTO';

@Injectable()
export class PODAdditionalDropService {
    constructor(
        private _http: HttpClient,
        private _toastr: BoToastrService,
        private _spinner: BoSpinnerService,
    ) { }

    public getPODAdditionalDrop(idDrop: string, disableSpinner?: boolean) {
        if (!disableSpinner) {
            this._spinner.show(true);
        }
        return this._http.get(`${API.POD_ADDITIONAL_DROP.GET(idDrop)}`)
            .pipe(tap(() => {
                this._spinner.hide();
            }),
                catchError((err: ErrorResponse) => {
                    this._spinner.hide();
                    this._toastr.errors(err.error.errors)
                    throw err;
                })
            );
    }
    public create(model: CreatePODAdditionalDrop) {
        return this._http.post(`${API.POD_ADDITIONAL_DROP.CREATE}`, model)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.CREATE_POD_ADDITIONAL);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }
    public update(idAdditionalDrops: string, model: CreatePODAdditionalDrop) {
        return this._http.put(`${API.POD_ADDITIONAL_DROP.PUT(idAdditionalDrops)}`, model)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.UPDATE_POD_ADDITIONAL);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            )
    }


}
